import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import DataListView from "../views/DataListView.vue";
import AddView from "../views/AddView.vue";
import MainLayout from "@/layout/MainLayout.vue";

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: "/",
    name: "home",
    component: DataListView,
    props: {
      mode: "molecule",
    },
  },
  {
    path: "/molecule",
    component: MainLayout,
    children: [
      {
        path: "",
        component: DataListView,
        props: {
          mode: "molecule",
        },
      },
      {
        path: "edit/:id",
        name: "edit molecule",
        component: AddView,
        props: {
          mode: "molecule",
          update: true,
        },
      },
      {
        path: "add",
        name: "add molecule",
        component: AddView,
        props: {
          mode: "molecule",
          add: true,
        },
      },
      {
        path: ":id",
        name: "show molecule",
        component: AddView,
        props: {
          mode: "molecule",
          show: true,
        },
      },
    ],
  },
  {
    path: "/family",
    component: MainLayout,
    children: [
      {
        path: "",
        component: DataListView,
        props: {
          mode: "family",
        },
      },
      {
        path: "edit/:id",
        name: "edit family",
        component: AddView,
        props: {
          mode: "family",
          update: true,
        },
      },
      {
        path: "add",
        name: "add family",
        component: AddView,
        props: {
          mode: "family",
          add: true,
        },
      },
      {
        path: ":id",
        name: "show family",
        component: AddView,
        props: {
          mode: "family",
          show: true,
        },
      },
    ],
  },
  {
    path: "/source",
    component: MainLayout,
    children: [
      {
        path: "",
        component: DataListView,
        props: {
          mode: "source",
        },
      },
      {
        path: "edit/:id",
        name: "edit source",
        component: AddView,
        props: {
          mode: "source",
          update: true,
        },
      },
      {
        path: "add",
        name: "add source",
        component: AddView,
        props: {
          mode: "source",
          add: true,
        },
      },
      {
        path: ":id",
        name: "show source",
        component: AddView,
        props: {
          mode: "source",
          show: true,
        },
      },
    ],
  },
  {
    path: "/synergy",
    component: MainLayout,
    children: [
      {
        path: "",
        component: DataListView,
        props: {
          mode: "synergy",
        },
      },
      {
        path: "edit/:id",
        name: "edit synergy",
        component: AddView,
        props: {
          mode: "synergy",
          update: true,
        },
      },
      {
        path: "add",
        name: "add synergy",
        component: AddView,
        props: {
          mode: "synergy",
          add: true,
        },
      },
      {
        path: ":id",
        name: "show synergy",
        component: AddView,
        props: {
          mode: "synergy",
          show: true,
        },
      },
    ],
  },
  { path: "*", redirect: "/" },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
